import Button from '~/components/UI/Button'

export default Button